import type { StoredDraft } from './localStorageDraft';

export function shouldShowResumeModal(draft: StoredDraft | null, search: string, pathname: string): boolean {
  if (!draft) return false;
  if (!draft.formData?.nombre?.trim()) return false;
  if (draft.step <= 1) return false;
  if (pathname.startsWith('/admin')) return false;
  // Sesiones addon/update vienen de Mi Cuenta con un propósito concreto:
  // ofrecer "Continuar plan de X" de un draft viejo aquí podría colar el
  // perro del draft en la suscripción del cliente.
  const params = new URLSearchParams(search);
  if (params.has('addon') || params.has('update')) return false;
  // /mi-cuenta se renderiza en una rama sin FormProvider (no monta el modal),
  // pero suprimimos aquí también por si el routing cambia en el futuro.
  if (pathname.startsWith('/mi-cuenta')) return false;
  return true;
}
